import { Banner } from '@repo/ui/Banner';
import { BannerTitle } from '@repo/ui/BannerTitle';
import { BannerMessage } from '@repo/ui/BannerMessage';

import { rawString } from '../Language/Language';
import { useWorkflow } from '../../workflow/hooks';

/**
 * Checks if any item in the workflow data has been overridden by an agent.
 */
const useHasOverriddenItems = (): boolean => {
  const { data } = useWorkflow();

  if (!data?.items) {
    return false;
  }

  return Object.values(data.items).some(
    (item) => item?.itemSelection?.isOverridden === true,
  );
};

/**
 * Banner displayed on the reasons step when an agent has overridden
 * an ineligible item to proceed with a claim.
 */
export const OverrideBanner = () => {
  const hasOverriddenItems = useHasOverriddenItems();

  const title = rawString({
    langKey: 'pdx.reason_selection.override_banner.title',
  });
  const message = rawString({
    langKey: 'pdx.reason_selection.override_banner.message',
  });

  if (!hasOverriddenItems || !title) {
    return null;
  }

  return (
    <Banner variant="info" ariaLabel={title}>
      <BannerTitle>{title}</BannerTitle>
      {message && <BannerMessage>{message}</BannerMessage>}
    </Banner>
  );
};
